import { render, staticRenderFns } from "./RestoreSiteDialog.vue?vue&type=template&id=0bb227f3&scoped=true&"
import script from "./RestoreSiteDialog.vue?vue&type=script&lang=js&"
export * from "./RestoreSiteDialog.vue?vue&type=script&lang=js&"
import style0 from "./RestoreSiteDialog.vue?vue&type=style&index=0&id=0bb227f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb227f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFileInput,VRow})
